import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Card, Container } from "react-bootstrap";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import { SubmitBar, Loader } from "@egovernments/digit-ui-react-components";
import ReactToPrint from "react-to-print";
import FormatSlip from "./FormatSlip";
import { ToWords } from "to-words";
import { useTranslation } from "react-i18next";

// const PaymentPrint = ({ id, formData , challanNo }) => {
//   // const { id } = useParams();
//   const { t } = useTranslation();
//   const stateId = Digit.ULBService.getStateId();
//   const conponentPDF = useRef();
//   const toWords = new ToWords();
//   const [loader, setLoader] = useState(false);
//   const [scrutinyTable, setScrutinyTable] = useState(null);
//   const [amountDetails, setAmountDetails] = useState(null);
//   const userInfo = Digit.UserService.getUser()?.info || {};
//   const getApplicationPay = async () => {
//     setLoader(true);
//     const token = window?.localStorage?.getItem("token");

  //   let requestInfo = {
  //     RequestInfo: {
  //       apiId: "Rainmaker",
  //       ver: "v1",
  //       ts: 0,
  //       action: "_search",
  //       did: "",
  //       key: "",
  //       msgId: "090909",
  //       requesterId: "",
  //       authToken: token,
  //       userInfo: userInfo,
  //     },
  //   };
  //   try {
  //     const Resp = await axios.post(`/pg-service/transaction/v1/_search?consumerCode=${id}`, requestInfo).then((response) => {
  //       return response?.data;
  //     });
  //     setLoader(false);
  //     console.log("Responsdhgdhdeygfg", Resp);
  //     setScrutinyTable(Resp?.Transaction?.[0]);
  //     const amountPaid = Resp?.Transaction?.[0]?.additionalDetails?.taxAndPayments[0]?.amountPaid;
  //     if (amountPaid) {
  //       const wordsList = toWords.convert(amountPaid, { currency: true, ignoreDecimal: false });
  //       setAmountDetails(wordsList);
  //       console.log("5555555555", wordsList);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

//   useEffect(() => {
//     getApplicationPay("");
//   }, [id]);
//   const { data: applicationData = {}, isLoading: paymentStatus } = Digit.Hooks.obps.useBPADetailsPage(stateId, { applicationNo: id });
//   const business_service = applicationData?.business_service;
//   const { eg_pg_txnid: egId, txnStatus: txn, workflow: workflw } = Digit.Hooks.useQueryParams();
//   // const { isLoading: paymentLoading, data, isError } = Digit.Hooks.usePaymentUpdate({ egId, txn }, business_service, {
//   //   retry: false,
//   //   staleTime: Infinity,
//   //   refetchOnWindowFocus: false,
//   // });
//   if (loader || paymentStatus) {
//     return <Loader />;
//   }
//   return (
//     <Container
//       className="justify-content-center"
//       style={{
//         minWidth: "100%",
//         maxWidth: "100%",
//         maxHeight: "50%",
//         minHeight: "40%",
//         marginTop: 5,
//       }}
//     >
//       <Card>
//         <div ref={conponentPDF}>
//           <div>
//             <FormatSlip
//               scrutinyTable={scrutinyTable}
//               scrutinyDetails={applicationData?.applicationData?.landInfo?.address}
//               scrutinyData={applicationData?.applicationData}
//               wordslist={amountDetails}
//               formData={formData}
//             />
//           </div>
//         </div>
//         {/* <Row className="justify-content-space-between" style={{ padding: "10px", marginTop: 20 }}>
//           <Col xs="4">
//             <Link to={`/digit-ui/citizen/profile`}>
//               <SubmitBar style={{ marginLeft: "85px" }} label={t("CORE_COMMON_GO_TO_HOME")} />
//             </Link>
//           </Col>
//           <Col xs="4"></Col>
//           <Col xs="4">
//             <ReactToPrint
//               trigger={() => <button class="btn btn-success" id="invoice-print">Print Payment Receipt</button>}
//               content={() => conponentPDF.current}
//             />
//           </Col>

//         </Row> */}
//       </Card>
//     </Container>
//   );
// };

// export default PaymentPrint;


const PaymentPrint = ({ id, formData, challanNo }) => {
  const { t } = useTranslation();
  const stateId = Digit.ULBService.getStateId();
  const conponentPDF = useRef();
  const toWords = new ToWords();

  const [loader, setLoader] = useState(false);
  const [scrutinyTable, setScrutinyTable] = useState(null);
  const [amountDetails, setAmountDetails] = useState(null);
  const [scrutinyTableTransaction, setScrutinyTableTransaction] = useState(null);

  const userInfo = Digit.UserService.getUser()?.info || {};

  const getApplicationPay = async () => {
    setLoader(true);

  const token = window?.localStorage?.getItem("token");

  const requestInfo = {
    RequestInfo: {
      apiId: "Rainmaker",
      ver: "v1",
      ts: 0,
      action: "_search",
      did: "",
      key: "",
      msgId: "090909",
      requesterId: "",
      authToken: token,
      userInfo: userInfo,
    },
  };

  try {
    // PG Transaction API
    const Resp = await axios
      .post(
        `/pg-service/transaction/v1/_search?consumerCode=${id}`,
        requestInfo
      )
      .then((response) => {
        return response?.data;
      });

    setLoader(false);

    console.log("Responsdhgdhdeygfg", Resp);

    // PG transaction response
    setScrutinyTableTransaction(
      Resp?.Transaction?.[0]
    );
// ---------------------------------------
      // FORM DATA taxHeadEstimates 
      // ---------------------------------------

      const taxHeadEstimates = formData?.taxHeadEstimates || [];

      // ---------------------------------------
      // Challan No. index 
      // ---------------------------------------

      const selectedIndex = taxHeadEstimates.findIndex(
        (item) => item?.challanNo === challanNo
      );

      console.log("Challan No1:", challanNo);
      console.log("Selected Index2:", selectedIndex);

      // ---------------------------------------
      // Index 
      // ---------------------------------------

      if (selectedIndex !== -1) {
        const selectedData = taxHeadEstimates[selectedIndex];

        console.log("Selected Table Data:", selectedData);

        //index  data table 
        setScrutinyTable(selectedData);

        // Amount  selected challan 
        const amountPaid = selectedData?.estimateAmount;

        console.log("Selected Amount:", amountPaid);

        if (amountPaid) {
          const wordsList = toWords.convert(
            Number(amountPaid),
            {
              currency: true,
              ignoreDecimal: false,
            }
          );

          setAmountDetails(wordsList);
        } else {
          setAmountDetails(null);
        }
      } else {
        console.log(
          "Challan not found:",
          challanNo
        );

        setScrutinyTable(null);
        setAmountDetails(null);
      }
      
    } catch (error) {
      console.error("Payment Error:", error);
      setScrutinyTable(null);
      setAmountDetails(null);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (id && challanNo && formData) {
      getApplicationPay();
    }
  }, [id, challanNo, formData]);

  const {
    data: applicationData = {},
    isLoading: paymentStatus,
  } = Digit.Hooks.obps.useBPADetailsPage(stateId, {
    applicationNo: id,
  });

  if (loader || paymentStatus) {
    return <Loader />;
  }

  return (
    <Container
      className="justify-content-center"
      style={{
        minWidth: "100%",
        maxWidth: "100%",
        maxHeight: "50%",
        minHeight: "40%",
        marginTop: 5,
      }}
    >
      <Card>
        <div ref={conponentPDF}>
          <FormatSlip
            scrutinyTable={scrutinyTable}
            scrutinyDetails={
              applicationData?.applicationData?.landInfo?.address
            }
            scrutinyTableTransaction={scrutinyTableTransaction}
            scrutinyData={applicationData?.applicationData}
            wordslist={amountDetails}
            formData={formData}
          />
        </div>
      </Card>
    </Container>
  );
};

export default PaymentPrint;